import React from 'react'
import { Trash2 } from 'lucide-react'

interface DeleteButtonProps {
  onClick: () => void
  size?: 'sm' | 'md'
  className?: string
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ 
  onClick, 
  size = 'sm',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'p-1',
    md: 'p-2'
  }

  return (
    <button
      onClick={onClick}
      className={`text-red-600 hover:text-red-700 hover:bg-red-50 rounded transition-colors ${sizeClasses[size]} ${className}`}
      title="削除"
    >
      <Trash2 className="icon" />
    </button>
  )
} 